
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.64515 12C6.43527 12 6.23301 11.9129 6.08314 11.7549L2.89726 8.50248C2.58991 8.1784 2.58991 7.64906 2.89726 7.32534C3.20462 7.00126 3.70664 7.00126 4.01365 7.32534L6.6226 9.96945L11.9605 4.27045C12.2527 3.93063 12.755 3.90686 13.0769 4.22291C13.3992 4.53094 13.4217 5.06061 13.122 5.40005L7.22969 11.7315C7.08743 11.8975 6.87755 12 6.66006 12L6.64515 12Z","fill":"white"}})])
          )
        }
      }
    